import { assessmentsConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { submitAssessmentLoading: true, data: '', error: false };

export function submitSingleRaterAssessment(state = initialState, action) {

    switch (action.type) {
        case assessmentsConstants.REQUEST_ASSESSMENT_SUBMIT:
            return {
                submitAssessmentLoading: true,
                data: '',
                error: false
            };
        case assessmentsConstants.RECEIVE_ASSESSMENT_SUBMIT:
        swal({
            text: "Assessment Submitted Successfully!",
            type: "success",
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                submitAssessmentLoading: false,
                data: action.onSubmitAssessment,
                error: false
            };
        case assessmentsConstants.ASSESSMENT_SUBMIT_ERROR:
            return {
                submitAssessmentLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/assessments/submitSingleRaterAssessment.reducer.js